import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

/**
 * E.164, the only shape Cognito accepts as `phone_number`. PhoneNumberInput emits E.164 once the
 * number is complete, but a partial or legacy value reaches submit as the text the user sees.
 */
export const toE164 = (value: string): string =>
  parsePhoneNumberFromString(value, 'FR')?.number ?? value;
